import { CustomImagePreview } from '../CustomImagePreview';
import { Main } from './style';
interface Props {
  imageUrl: string;
  altText: string;
  isInbox?: boolean;
  isMargin?: boolean;
  isImage?: boolean;
  type?: 'Figma' | 'Inbox' | 'PrintScreen' | 'Youtube' | 'ScreenRecording' | 'Image';
}

export const RenderImagePreview = (props: Props) => {
  const { imageUrl, altText, isInbox, isMargin, isImage, type } = props || {};
  // Other variables
  return (
    <Main isMargin={isMargin} onClick={(e) => e.stopPropagation()} isImage={isImage}>
      <CustomImagePreview src={imageUrl} alt={altText} isInbox={isInbox} type={type} />
    </Main>
  );
};
